import { OverviewTeamSectionEmptyState_organization$key } from '#app/__generated__/relay/OverviewTeamSectionEmptyState_organization.graphql.js';
import { Button } from '#app/components/Buttons/Button.js';
import { Text } from '#app/components/Primitives/Text.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { useNavigation } from '#app/hooks/useNavigation.js';
import EmptyStateImage from './assets/team-empty.webp';
import {
  EmptyStateCard,
  Image,
  MessageContainer,
} from './EmptyState.styles.js';
import { graphql, useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';
import { useCallback } from 'react';

type OverviewTeamSectionEmptyStateProps = {
  readonly organizationRef: OverviewTeamSectionEmptyState_organization$key;
};

export const OverviewTeamSectionEmptyState = ({
  organizationRef,
}: OverviewTeamSectionEmptyStateProps) => {
  const organization =
    useFragment<OverviewTeamSectionEmptyState_organization$key>(
      graphql`
        fragment OverviewTeamSectionEmptyState_organization on Organization {
          name
          visitorIsMember
        }
      `,
      organizationRef,
    );
  const { track } = useAnalytics();
  const navigation = useNavigation();

  const isMember = organization.visitorIsMember;

  const onClick = useCallback(() => {
    track('button', {
      action: 'tapped',
      button_name: 'company_profile_owner_empty_state_invite_teammates',
    });

    navigation.push(getRoute('/company/invite-teammates'));
  }, [navigation, track]);

  return (
    <EmptyStateCard>
      <Image
        alt="Image of a project listing with a 3D glass shopping bag behind it"
        src={EmptyStateImage}
      />
      <MessageContainer>
        <Text
          as="h3"
          color="gray80"
          textStyle="subtitleRegular"
        >
          {organization.name ?? 'Organization'} does not have any teammates,
          yet!
        </Text>
        <Text
          color="gray70"
          textStyle="bodySmall"
        >
          {isMember ? (
            <>
              Your teammates will be displayed here. Invite your team to start
              collaborating on projects.
            </>
          ) : (
            <>
              As {organization.name ?? 'Organization'} adds their teammates,
              you'll be able to view them on this page.
            </>
          )}
        </Text>
        {isMember ? (
          <Button
            onClick={onClick}
            removeMinWidth
            size="small"
            variant="V2Primary"
          >
            Invite teammates
          </Button>
        ) : null}
      </MessageContainer>
    </EmptyStateCard>
  );
};
